export default __webpack_public_path__ + "static/media/logo_oficinal_unjbg.60e1a0ab.png";